import * as React from 'react';
import { BookOpenIcon } from '@heroicons/react/outline';
import { HiSparkles } from 'react-icons/hi2';
import FlowAiAnalysisUpdateStatus from 'layouts/FlowPageContainer/FlowAiAnalysisUpdateStatus';

interface Props {
  lastUpdated: string | null;
  isLoading: boolean;
  onClose: () => void;
  onAbout: () => void;
  isGuideOpen: boolean;
  guideId: string;
  infoButtonRef: React.RefObject<HTMLButtonElement>;
  closeButtonRef?: React.MutableRefObject<HTMLButtonElement | null>;
}
export default function FlowAiAnalysisHeader({
  lastUpdated,
  isLoading,
  onClose,
  onAbout,
  isGuideOpen,
  guideId,
  infoButtonRef,
  closeButtonRef,
}: Props) {
  return (
    <div
      className="grid shrink-0 grid-cols-[1fr_auto] items-center gap-x-2 border-b border-palette-border bg-palette-black-3 px-4 py-2 sm:flex sm:gap-3 sm:px-6 sm:py-3"
      data-analysis-header
    >
      <div className="flex shrink-0 items-center">
        <HiSparkles aria-hidden="true" className="mr-2 hidden h-4 w-4 text-call-text md:block" />
        <h2 className="text-base font-semibold text-white md:text-lg">AI Market Analysis</h2>
        <button
          type="button"
          ref={infoButtonRef}
          aria-label="How to use AI Market Analysis"
          aria-expanded={isGuideOpen}
          aria-controls={guideId}
          onClick={onAbout}
          className={`group/guide relative ml-2 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md transition-colors hover:bg-white/[0.05] hover:text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-blue [@media(pointer:coarse)]:after:absolute [@media(pointer:coarse)]:after:-inset-2.5 [@media(pointer:coarse)]:after:content-[''] ${
            isGuideOpen ? 'bg-white/[0.08] text-text-primary' : 'text-text-secondary'
          }`}
        >
          <BookOpenIcon className="h-4 w-4" aria-hidden="true" />
          <span
            aria-hidden="true"
            className="pointer-events-none absolute left-1/2 top-full z-[70] mt-1.5 hidden -translate-x-1/2 whitespace-nowrap rounded-md bg-palette-black-1 px-2 py-1 text-[11px] font-semibold text-text-primary shadow-lg ring-1 ring-white/[0.09] group-hover/guide:block group-focus-visible/guide:block"
          >
            {isGuideOpen ? 'Back to analysis' : 'Analysis guide'}
          </span>
        </button>
      </div>
      <div className="col-span-2 row-start-2 min-w-0 pb-2 sm:ml-auto sm:pb-0">
        <FlowAiAnalysisUpdateStatus lastUpdated={lastUpdated} isLoading={isLoading} />
      </div>
      <button
        type="button"
        ref={closeButtonRef}
        aria-label="Close AI analysis"
        onClick={onClose}
        className="col-start-2 row-start-1 flex h-11 w-11 shrink-0 items-center justify-center rounded-md text-text-secondary transition-colors hover:bg-white/[0.06] hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-blue"
      >
        <svg
          aria-hidden="true"
          className="h-5 w-5 sm:h-6 sm:w-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  );
}
